module.exports = __webpack_public_path__ + "img/iconfinder_view-grid.52a7afd5.svg";